import template from './ecocode-trustpilot-first-run-wizard.html.twig';

const { Component } = Shopware;

Component.register('ecocode-trustpilot-first-run-wizard', {
    template
});
